import { identity } from 'lodash';
import { createSelector } from 'reselect';
import * as modalNames from './modals.module';
import { toLookup } from '../../../utils/utils';

export const getModals = (state) => state.modals;
export const getModalsSeen = (state) => state.modals.modalsSeen;
/**
 * Returns a modals lookup that guarantees every modal has a props object to
 * simplify extracting props.
 * @function
 * @param state
 * @return {Object.<string, object>}
 */
export const getModalProps = createSelector(getModals, (modals) => ({
  ...toLookup(
    Object.keys(modalNames).filter(
      (name) => typeof name === 'string' && name === name.toUpperCase()
    ),
    identity,
    () => {}
  ),
  ...modals,
}));
